import { FormControlLabel, Switch } from '@mui/material';
import Text from 'components/commons/Text';
import { CountButton } from 'components/input/CountButton';
import InputField from 'components/input/InputField';
import LocalizeInput from 'components/input/LocalizeInput';
import LocalizeEditor from 'components/input/LocalizeEditor';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Row, Select, useModelStateContext } from 'saladsoft-primitive';
import { AdminListingRequestDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import styled from 'styled-components';
import DaumPostcodeEmbed from 'react-daum-postcode';
import { translateText } from 'libs/helper/translationHelper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Swiper as SwiperType } from 'swiper';
import PageLayout from 'components/layouts/PageLayout';
import { useNavigate } from 'react-router-dom';
import { Container as MapDiv, NaverMap, Marker, useNavermaps } from 'react-naver-maps';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';

const NewListingPage = () => {
  const { setState, stateModel, updateServiceModel, setMultipleState, serviceModel, unmountModel } =
    useModelStateContext<AdminListingRequestDto>();
  const { uiStore } = useStoreWrapper();
  const navigate = useNavigate();
  const navermaps = useNavermaps();
  const tabs = [
    { seq: 0, title: '시설명' },
    { seq: 1, title: '주소 및 위치' },
    { seq: 2, title: '한줄 소개' },
    { seq: 3, title: '시설 설명' },
    { seq: 4, title: '시설 정보' },
  ];

  const generateHourOptions = () => {
    return Array.from(Array(24).keys()).map((i) => ({
      key: i.toString().padStart(2, '0'),
      value: i.toString().padStart(2, '0'),
    }));
  };

  const [hourOptions] = useState(generateHourOptions());

  const [currentTab, setCurrentTab] = useState<{ seq: number; title: string }>(tabs[0]);
  const [regions, setRegions] = useState<Record<string, any>[]>([]);
  const [businesses, setBusinesses] = useState<Record<string, any>[]>([]);
  const [swiperRef, setSwiperRef] = useState<SwiperType>();
  const [mapKey, setMapKey] = useState(0);
  const [regionError, setRegionError] = useState(false);

  const handleClickFindAddress = () => {
    uiStore?.modal.show({
      title: '주소찾기',
      style: { width: 500, maxHeight: '80%', height: 'auto' },
      children: <DaumPostcodeEmbed style={{ height: '500px' }} onComplete={onCompletePost} />,
    });
  };

  const registerListing = async () => {
    if (!serviceModel.current) return;
    uiStore?.confirm.show({
      title: '시설을 생성하시겠습니까? \r\n최초등록은 "비활성"상태로 등록됩니다.',
      onConfirmed: async () => {
        const result = await ServiceHelper?.adminListingService?.createListing(
          serviceModel.current as AdminListingRequestDto,
        );

        if (result?.status === 200) {
          toast.success('시설이 정상적으로 생성되었습니다.');
          navigate(`/admin/listings/${result?.data?.id}/photos`);
        } else {
          const newResult = result as any;
          toast.error(newResult.response.data.errorCode);
        }
      },
    });
  };

  const onCompletePost = async (post: any) => {
    const jp = await translateText(post.address, 'ja');
    const zh = await translateText(post.address, 'zh');
    setState('localizedAddress', {
      ko: post.address,
      en: post.addressEnglish,
      ja: jp as string,
      zh: zh as string,
    });

    if (post.address) {
      navermaps.Service.geocode(
        {
          address: post.address,
        },
        function (status: any, response: any) {
          if (status !== navermaps.Service.Status.OK) {
            toast.error('지도 취득에 실패했습니다.');
            return;
          }
          const items = response.result.items; // Array of the search result
          setState('latitude', items[0].point.y);
          setState('longitude', items[0].point.x);
          setMapKey((prev) => prev + 1);
        },
      );
    }
    uiStore?.modal.close();
  };

  useEffect(() => {
    setMultipleState({
      seq: 1,
      hasParking: false,
      minGuest: 2,
      maxGuest: 2,
      size: 0,
      isActive: false,
      checkInTime: 15,
      checkOutTime: 11,
    });

    ServiceHelper?.adminBusinessService?.getBusinesses().then((res) => {
      const formattedBusinesses =
        res?.data
          ?.map((business: any) => ({
            key: business.id,
            value: business.name,
            isDefault: business.isDefault,
          }))
          .sort((a, b) => (b.isDefault ? 1 : a.isDefault ? -1 : 0)) || [];
      setBusinesses(formattedBusinesses);
      const primaryBusiness = res.data.find((business) => business.isPrimary);

      if (primaryBusiness) {
        updateServiceModel('business', { id: primaryBusiness.id });
      }
    });

    ServiceHelper?.adminRegionService?.getRegions1().then((res) => {
      const formattedRegions =
        res?.data?.map((region: any) => ({
          key: region.id,
          value: region.localizedName.ko,
        })) || [];
      setRegions(formattedRegions);
    });
  }, []);

  const handleTabClick = (tab: { seq: number; title: string }) => {
    setCurrentTab(tab);
    swiperRef?.slideTo(tab.seq);
  };

  const NewHeader = () => {
    return (
      <Row justifyContent="flex-start">
        {tabs.map((tab) => (
          <TabItem
            isActive={tab.seq === currentTab.seq}
            key={tab.seq}
            onClick={() => handleTabClick(tab)}
          >
            {tab.title}
          </TabItem>
        ))}
      </Row>
    );
  };
  const PageTitle = () => {
    return (
      <Row gap="10px" padding="0 20px">
        <Text type="H2">신규 시설등록</Text>
      </Row>
    );
  };

  useEffect(() => {
    return () => {
      unmountModel();
    };
  }, []);

  const handleRegisterListing = async () => {
    if (!stateModel?.region?.id) {
      setRegionError(true);
      toast.warning('시설의 위치를 선택해주세요.');
      return;
    }
    registerListing();
  };

  return (
    <PageLayout
      title={<PageTitle />}
      style={{ maxWidth: 1200, margin: 'auto', padding: 0 }}
      actionButton={<NewHeader />}
      useStickyHeader={true}
    >
      <Wrapper>
        <Swiper
          spaceBetween={10}
          onSwiper={setSwiperRef}
          speed={0}
          allowTouchMove={false}
          autoHeight={true}
          onSlideChange={(swiper) => {
            setCurrentTab(tabs[swiper.activeIndex]);
          }}
        >
          <SwiperSlide key={'tab_1'}>
            <InnerSection style={{ minHeight: '500px' }}>
              <InnerGroup>
                <div>
                  <Text type="H3" style={{ marginBottom: 10 }}>
                    시설명 등록
                  </Text>
                  <Text type="H4" buttonRole="DESCRIPTION">
                    시설의 명칭을 입력하여 주세요.
                  </Text>
                  <Text
                    buttonRole="DESCRIPTION"
                    style={{ fontSize: 12, color: 'var(--point-color)', marginTop: 2 }}
                  >
                    * 모든 입력값은 필수입니다.
                  </Text>
                </div>

                <LocalizeInput onChange={(value) => setState('localizedName', value)} />
              </InnerGroup>
              <ButtonWrapper>
                <Button type="outlined" onClick={() => navigate('/admin/listings')}>
                  생성 취소
                </Button>
                <Button onClick={() => swiperRef?.slideTo(1)}>다음</Button>
              </ButtonWrapper>
            </InnerSection>
          </SwiperSlide>
          <SwiperSlide key={'tab_2'}>
            <InnerSection style={{ minHeight: '500px' }}>
              <InnerGroup>
                <div>
                  <Text type="H3" style={{ marginBottom: 10 }}>
                    주소 등록
                  </Text>
                  <Text type="H4" buttonRole="DESCRIPTION">
                    시설의 주소를 입력하여 주세요.
                    <br />
                    아래의 버튼으로 주소검색이 가능합니다.
                    <br />
                    <span style={{ fontSize: 12, color: 'var(--point-color)', paddingTop: 10 }}>
                      * 영어 외의 언어는 구글번역을 이용합니다.
                    </span>
                    <Text
                      buttonRole="DESCRIPTION"
                      style={{ fontSize: 12, color: 'var(--point-color)', marginTop: 2 }}
                    >
                      * 모든 입력값은 필수입니다.
                    </Text>
                  </Text>
                  <Button
                    type="outlined"
                    onClick={handleClickFindAddress}
                    style={{ marginTop: '20px', width: 150 }}
                  >
                    주소검색
                  </Button>
                </div>

                <LocalizeInput
                  defaultValue={stateModel?.localizedAddress}
                  value={stateModel?.localizedAddress}
                  onChange={(value) => setState('localizedAddress', value)}
                />
              </InnerGroup>
              {stateModel?.latitude && stateModel?.longitude && (
                <InnerGroup>
                  <MapWrapper>
                    <MapDiv
                      key={mapKey}
                      style={{
                        width: '100%',
                        height: '400px',
                      }}
                    >
                      <NaverMap
                        defaultCenter={
                          new navermaps.LatLng(stateModel?.latitude, stateModel?.longitude)
                        }
                        defaultZoom={19}
                      >
                        <Marker
                          defaultPosition={
                            new navermaps.LatLng(stateModel?.latitude, stateModel?.longitude)
                          }
                        />
                      </NaverMap>
                    </MapDiv>
                  </MapWrapper>
                </InnerGroup>
              )}

              <ButtonWrapper>
                <Button type="outlined" onClick={() => navigate('/admin/listings')}>
                  생성 취소
                </Button>
                <Row gap={10}>
                  <Button type="outlined" onClick={() => swiperRef?.slideTo(0)}>
                    이전
                  </Button>
                  <Button onClick={() => swiperRef?.slideTo(2)}>다음</Button>
                </Row>
              </ButtonWrapper>
            </InnerSection>
          </SwiperSlide>
          <SwiperSlide key={'tab_3'}>
            <InnerSection style={{ minHeight: '500px' }}>
              <InnerGroup>
                <div>
                  <Text type="H3" style={{ marginBottom: 10 }}>
                    한줄소개
                  </Text>
                  <Text type="H4" buttonRole="DESCRIPTION">
                    시설을 잘 표현할 수 있는 한줄 소개를 입력해 주세요.
                    <br />
                  </Text>
                  <Text
                    buttonRole="DESCRIPTION"
                    style={{ fontSize: 12, color: 'var(--point-color)', marginTop: 2 }}
                  >
                    * 모든 입력값은 필수입니다.
                  </Text>
                </div>
                <LocalizeInput onChange={(value) => setState('localizedTitle', value)} />
              </InnerGroup>
              <ButtonWrapper>
                <Button type="outlined" onClick={() => navigate('/admin/listings')}>
                  생성 취소
                </Button>
                <Row gap={10}>
                  <Button type="outlined" onClick={() => swiperRef?.slideTo(1)}>
                    이전
                  </Button>
                  <Button onClick={() => swiperRef?.slideTo(3)}>다음</Button>
                </Row>
              </ButtonWrapper>
            </InnerSection>
          </SwiperSlide>
          <SwiperSlide key={'tab_4'}>
            <InnerSection>
              <InnerGroup>
                <div>
                  <Text type="H3" style={{ marginBottom: 10 }}>
                    시설 설명
                  </Text>
                  <Text type="H4" buttonRole="DESCRIPTION">
                    상세 설명은 HTML형식으로 입력 및 편집이 가능합니다.
                    <br />
                  </Text>
                  <Text
                    buttonRole="DESCRIPTION"
                    style={{ fontSize: 12, color: 'var(--point-color)', marginTop: 2 }}
                  >
                    * 모든 입력값은 필수입니다.
                  </Text>
                </div>
                <LocalizeEditor onChange={(value) => setState('localizedDesc', value)} />
              </InnerGroup>
              <ButtonWrapper>
                <Button type="outlined" onClick={() => navigate('/admin/listings')}>
                  생성 취소
                </Button>
                <Row gap={10}>
                  <Button type="outlined" onClick={() => swiperRef?.slideTo(2)}>
                    이전
                  </Button>
                  <Button onClick={() => swiperRef?.slideTo(4)}>다음</Button>
                </Row>
              </ButtonWrapper>
            </InnerSection>
          </SwiperSlide>
          <SwiperSlide key={'tab_5'}>
            <InnerSection style={{ minHeight: '500px', width: '100%' }}>
              <Row flexDirection="column" gap={66} alignItems="flex-start" width="100%">
                <InnerGroup>
                  <div>
                    <Text type="H3" style={{ marginBottom: 10 }}>
                      소유사업자 선택
                    </Text>
                    <Text type="H4" buttonRole="DESCRIPTION">
                      시설의 소유사업자를 선택 해 주세요.
                      <WarningText>
                        *해당사업자의 MID를 이용해 결제가 되며, 숙소 상세 및 결제페이지의 푸터에
                        표시됩니다.
                      </WarningText>
                    </Text>
                  </div>

                  <Select
                    placeHolder="사업자선택"
                    items={businesses}
                    defaultKey={businesses[0]?.key}
                    onChange={(value) => setState('business', { id: value.key })}
                  />
                </InnerGroup>

                <InnerGroup>
                  <div>
                    <Text type="H3" style={{ marginBottom: 10 }}>
                      시설위치 선택
                    </Text>
                    <Text type="H4" buttonRole="DESCRIPTION">
                      시설의 위치를 선택 해 주세요. <br />
                      단일선택만 가능합니다.
                    </Text>
                  </div>
                  <Select
                    containerStyle={{
                      border: `1px solid ${regionError ? 'red' : '#ddd'}`,
                    }}
                    placeHolder="위치선택"
                    items={regions}
                    onChange={(value) => {
                      setRegionError(false);
                      setState('region', { id: value.key });
                    }}
                  />
                </InnerGroup>

                <InnerGroup>
                  <div>
                    <Text type="H3" style={{ marginBottom: 10 }}>
                      인원수 설정
                    </Text>
                    <Text type="H4" buttonRole="DESCRIPTION">
                      시설의 위치를 선택 해 주세요. <br />
                      단일선택만 가능합니다.
                    </Text>
                  </div>
                  <Row gap="50px" justifyContent="flex-start">
                    <div>
                      <Row flexDirection="column" alignItems="flex-start" gap={10}>
                        <Text type="H4" style={{ fontWeight: 500 }}>
                          최소 인원 수
                        </Text>
                        <CountButton
                          count={
                            stateModel?.maxGuest &&
                            stateModel?.minGuest &&
                            stateModel.maxGuest < stateModel.minGuest
                              ? stateModel.maxGuest
                              : 2
                          }
                          maxCount={stateModel?.maxGuest || 10}
                          onChange={(count: number) => {
                            if (count > (serviceModel.current?.maxGuest || 0)) {
                              toast.warning('최대 인원보다 클 수 없습니다.');
                              return;
                            }
                            setState('minGuest', count);
                          }}
                        />
                      </Row>
                      <Row flexDirection="column" alignItems="flex-start" marginTop={30} gap={10}>
                        <Text type="H4" style={{ fontWeight: 500 }}>
                          입실가능한 최대 인원 수
                        </Text>
                        <CountButton
                          count={2}
                          maxCount={10}
                          onChange={(count: number) => {
                            setState('maxGuest', count);
                          }}
                        />
                      </Row>
                      {/* <Row flexDirection="column" alignItems="flex-start" marginTop={30} gap={10}>
                      <Text type="H4" style={{ fontWeight: 500 }}>
                        인원당 추가비용
                      </Text>
                      <InputField
                        style={{ width: 265 }}
                        type="number"
                        onChange={(value) => updateServiceModel('extraPersonPrice', Number(value))}
                      />
                    </Row> */}
                    </div>
                  </Row>
                </InnerGroup>
                <InnerGroup>
                  <div>
                    <Text type="H3" style={{ marginBottom: 10 }}>
                      기타정보 설정
                    </Text>
                    <Text type="H4" buttonRole="DESCRIPTION">
                      시설의 크기 및 청소비용등의 <br />
                      정보를 입력 해주세요.
                    </Text>
                  </div>
                  <Row
                    gap={10}
                    flexDirection="column"
                    alignItems="flex-start"
                    justifyContent="flex-start"
                  >
                    <Row
                      flexDirection="column"
                      justifyItems="flex-start"
                      alignItems="flex-start"
                      gap={10}
                    >
                      <Text type="H4" style={{ fontWeight: 500 }}>
                        시설의 크기(㎡)
                      </Text>
                      <InputField
                        style={{ width: 265 }}
                        type="number"
                        onChange={(value) => updateServiceModel('size', Number(value))}
                      />
                    </Row>
                    {/* <Row flexDirection="column" alignItems="flex-start" marginTop={30} gap={10}>
                      <Text type="H4" style={{ fontWeight: 500 }}>
                        청소비용
                      </Text>
                      <InputField
                        style={{ width: 265 }}
                        type="number"
                        onChange={(value) => updateServiceModel('', Number(value))}
                      />
                    </Row> */}
                    <Row flexDirection="column" alignItems="flex-start" marginTop={30} gap={10}>
                      <Text type="H4" style={{ fontWeight: 500 }}>
                        주차가능여부
                      </Text>
                      <FormControlLabel
                        control={
                          <Switch
                            size="medium"
                            defaultChecked={false}
                            onChange={(e) => setState('hasParking', e.target.checked)}
                          />
                        }
                        label=""
                      />
                    </Row>

                    <div style={{ marginTop: 30 }}>
                      <Text type="H4" style={{ fontWeight: 500, paddingBottom: 15 }}>
                        체크인/체크아웃 시간
                      </Text>
                      <Row gap={10} marginBottom={10} justifyContent="flex-start">
                        <Select
                          itemBoxStyle={{ height: 200, overflow: 'auto' }}
                          fullWidth={true}
                          style={{ minWidth: 250 }}
                          containerStyle={{}}
                          defaultKey={'15'}
                          placeHolder="체크인 시간선택"
                          items={hourOptions}
                          onChange={(value: Record<string, any>) => {
                            updateServiceModel('checkInTime', value.value);
                            // setCheckinHour(value.value);
                          }}
                          useRound={false}
                        />

                        <Select
                          placeHolder="체크아웃 시간선택"
                          itemBoxStyle={{ height: 200, overflow: 'auto' }}
                          style={{ minWidth: 250 }}
                          defaultKey={'11'}
                          items={hourOptions}
                          onChange={(value: Record<string, any>) => {
                            updateServiceModel('checkOutTime', value.value);
                            // setCheckoutHour(value.value);
                          }}
                          useRound={false}
                        />
                      </Row>
                    </div>
                  </Row>
                </InnerGroup>
              </Row>
              <ButtonWrapper>
                <Button
                  type="outlined"
                  onClick={() => {
                    navigate('/admin/listings');
                  }}
                >
                  생성취소
                </Button>
                <Row gap={10}>
                  <Button type="outlined" onClick={() => swiperRef?.slideTo(3)}>
                    이전
                  </Button>
                  <Button
                    style={{ background: 'var(--point-color)' }}
                    onClick={handleRegisterListing}
                  >
                    시설 생성하기
                  </Button>
                </Row>
              </ButtonWrapper>
            </InnerSection>
          </SwiperSlide>
        </Swiper>
      </Wrapper>
    </PageLayout>
  );
};

const Wrapper = styled.div`
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
`;

const ButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

const MapWrapper = styled.div`
  width: 100%;
  flex: 1;
  height: 400px;
  margin-top: 20px;
  border-radius: 10px;
  overflow: hidden;
`;

const TabItem = styled.div<{ isActive: boolean }>`
  cursor: pointer;
  padding: 5px 20px;
  border-bottom: 2px solid ${({ isActive }) => (isActive ? 'var(--point-color)' : '#c6c6c6')};
  /* border-bottom: 2px solid #c6c6c6; */
  font-weight: ${({ isActive }) => (isActive ? 'bold' : 'normal')};
`;

const WarningText = styled.div`
  color: var(--point-color);
  font-size: 12px;
`;

export default NewListingPage;
